import { apiCall } from '../helpers/apiHelpers';

export const passResetService = apiCall({
  method: 'POST',
  url: '/api/client/refreshpassword',
});
